<template>
  <div id="manutencao">
    <img
      src="../assets/logo.png"
      alt="Empório das Marcas"
      id="logo_manutencao"
    />
    <h1 style="color: #000">Estamos em manutenção!</h1>
    <p style="color: #000">Voltaremos em breve!</p>
    <a href="https://www.instagram.com/emporiodasmarcas_" id="instagram"
      ><img
        src="https://img.icons8.com/material/48/000000/instagram-new--v1.png"
        id="icons_instagram"
    /></a>
  </div>
</template>

<script>
export default {
  mounted() {
    this.load();
  },
  methods: {
    async load() {
        setTimeout(async () => {
          try {
            await this.$http.get("/projects/status");
            this.$router.push("/");
          } catch (err) {
            this.load();
          }
        }, 3000);

    },
  },
};
</script>

<style>
#manutencao {
  margin: 0 auto;
  background-color: #fff;
  padding-bottom: 1%;
  justify-self: center;
}

#manutencao h1 {
  margin-top: 20%;
  text-transform: uppercase;
}

#manutencao p {
  margin-top: 10px;
  text-transform: uppercase;
}

#instagram {
  text-align: center;
}

#icons_instagram {
  text-align: center;
  height: 40px;
  margin-top: 20px;
  object-fit: contain;
}

#logo_manutencao {
  height: 150px;
  margin-top: 100px;
  object-fit: contain;
}
</style>